import ServiceBase from './serviceBase';
import {
  Calculation,
  CalculatorContextType,
  CalculatorRowDto,
  CalculatorUrbanDto,
  UrbanContextType,
} from './types/Calculator';

class CalculatorService extends ServiceBase {
  getCalculatorContext = async (operationId: string): Promise<CalculatorContextType> =>
    this.get<CalculatorContextType>(`calculator/${operationId}/calculatorcontext`);

  getRows = async (operationId: number): Promise<Calculation[]> =>
    this.get<Calculation[]>(`calculator/${operationId}/rows`);

  /*
  getCalculatorSectorContext = async (operationId: string): Promise<CalculatorContextType> => {
    return this.get<CalculatorContextType>(`calculator/${operationId}/calculator-sector-context`);
  }; */

  getCalculatorSectorContext = async (calculatorId: string): Promise<UrbanContextType> =>
    this.get<UrbanContextType>(`calculator/${calculatorId}/urban-sector-context`);

  addCalculatorRow = async (payload: CalculatorRowDto): Promise<void> =>
    this.post<void>(`calculator/addrow`, payload);

  saveCalculatorUrban = async (payload: CalculatorUrbanDto): Promise<void> =>
    this.post<void>(`calculator/saveUrban`, payload);

  finishCalculatorUrban = async (payload: CalculatorUrbanDto): Promise<void> =>
    this.post<void>(`calculator/finishUrban`, payload);

  sendCalculator = async (operationId: number): Promise<void> =>
    this.post<void>(`calculator/${operationId}/sendCalculator`);

  createFromMostRecent = async (operationId: number): Promise<void> =>
    this.post<void>(`calculator/${operationId}/createFromMostRecent`);

  deleteRow = async (rowId: number): Promise<void> => this.delete(`calculator/row/${rowId}`);

  downloadDocument = async (calculatorId: number): Promise<boolean> => {
    await this.download(`calculator/${calculatorId}/download`);
    return true;
  };

  downloadDocumentTotals = async (operationId: number, version?: number): Promise<boolean> => {
    const query = version !== undefined ? `?version=${version}` : '';
    await this.download(`calculator/${operationId}/downloadTotals${query}`);
    return true;
  };
}

const calculatorService = new CalculatorService();

export default calculatorService;
